export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$dir', {
      get() {
        return {
          rtl: this.$t('direction') === 'rtl',
          ltr: this.$t('direction') === 'ltr'
        }
      }
    })
  }
}
